/** 2018/12/22
 *作者:Cookie
 *功能: 路由挂在配置
 */

import Vue from 'vue';
import Router from 'vue-router';
import constantRouterMap from './path';
import {afterEach, beforeEach} from './interceptor';
import store from '../store/index';

Vue.use(Router);
const router = new Router({
  base: process.env.BASE_URL,
  routes: constantRouterMap
});
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};
router.beforeEach(beforeEach);
router.afterEach(afterEach);

Vue.mixin({
  beforeRouteLeave(to, from, next) {
    let list = store.getters['tags/cachedViews'];
    if (to.name === 'login' || to.name === 'servicelogin') {
      this.$vnode.parent.componentInstance.cache = {};
    }

    function listIndex(tag) {
      let name = tag.split('-');
      return list.findIndex(v => v === name[name.length - 1]);
    }

    //通过$vNode强制删除cache中不存在cachedViews中的组件
    if (this.$vnode && this.$vnode.data.keepAlive) {
      if (this.$vnode.parent && this.$vnode.parent.componentInstance && this.$vnode.parent.componentInstance.cache) {
        if (this.$vnode.componentOptions) {
          let key = this.$vnode.key == null
            ? this.$vnode.componentOptions.Ctor.cid + (this.$vnode.componentOptions.tag ? `::${this.$vnode.componentOptions.tag}` : '')
            : this.$vnode.key;
          let cache = this.$vnode.parent.componentInstance.cache;
          let keys = this.$vnode.parent.componentInstance.keys;
          let re = false;
          //判断该组件下含有子组件在cachedViews中，则不清除cache
          cache[key] && cache[key].child.$children ? re = cache[key].child.$children.findIndex(v => listIndex(v.$vnode.tag) >= 0) >= 0 : '';
          if (cache[key] && listIndex(cache[key].tag) < 0 && !re) {
            if (keys.length) {
              let index = keys.indexOf(key);
              if (index > -1) {
                keys.splice(index, 1);
              }
            }
            delete cache[key];
          }
        }
      }
    }
    next()
  }
});

export default router;
